export default __webpack_public_path__ + "static/media/cert-0x3.e5de962e.svg";